import 'babel-polyfill'
import '@/core/prototype-modifications'
import '@/assets/styles/common/_common.scss'
import '@/core/signaling'
import 'svgxuse'
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import i18n from '@/core/localization/i18n'
import VModal from 'vue-js-modal'
import Toasted from 'vue-toasted'
import globalMixin from '@/mixins/global'
import { registerComponents } from '@/core/startup'
import vuetify from '@/core/vendor/vuetify-wrap'
import { setCurrentThemeColorsOrDefault } from '@/core/services/theme-service'

store.dispatch('checkAuth')
setCurrentThemeColorsOrDefault()
registerComponents()

Vue.config.productionTip = false

Vue.use(Toasted, { position: 'bottom-center', duration: 5000 })
Vue.use(VModal, { dialog: true })
Vue.mixin(globalMixin)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  vuetify,
  template: '<App/>',
  components: { App },
  i18n
})
